import React, { ReactNode } from 'react'
import { Flex, Text } from '@clear/design-system'
import { ColorType } from '@clear/design-system/lib/theme/colors'

type BannerAlertProps = {
  children: ReactNode
  backgroundColor?: string
}

export default function BannerAlert({
  children,
  backgroundColor = 'brandDarkBlue',
}: BannerAlertProps) {
  return (
    <Flex
      backgroundColor={backgroundColor as ColorType}
      p={4}
      justifyContent="center"
    >
      <Text color="neutralsWhite" fontFamily="Inter-SemiBold">
        {children}
      </Text>
    </Flex>
  )
}
